import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`background-image: url(img/${ _ctx.picture }.png); background-size: cover;`)
  }, null, 4 /* STYLE */))
}